import { Box, Text } from "@chakra-ui/react";
import { ResultBlock } from "./ResultBlock";

const GROUP_TITLES = {
  cerveja: "Cervejas",
};

// Stacked rather than a 2-column grid: this card renders at very different
// widths depending on context (full-width standalone page vs. sharing a row
// with the hero's marketing copy), and Chakra's responsive columns key off
// the viewport, not this component's actual available width — a 2-up grid
// looked fine at some viewport/container combinations and badly squeezed the
// product rows at others. Stacking is correct at any width.
export function ResultGroup({ groupKey, items, itemQuantities, setItemQuantities }) {
  return (
    <Box>
      <Text
        fontSize="11px"
        fontWeight="800"
        color="rgba(0,74,51,.5)"
        textTransform="uppercase"
        letterSpacing="0.04em"
        mb="6px"
      >
        {GROUP_TITLES[groupKey] || "Combinação"}
      </Text>
      <Box display="flex" flexDirection="column" gap="10px">
        {items.map((result) => (
          <ResultBlock
            key={result.key}
            result={result}
            itemQuantities={itemQuantities}
            setItemQuantities={setItemQuantities}
          />
        ))}
      </Box>
    </Box>
  );
}
